import React, { useState, useEffect } from 'react' 
import { NavLink, useNavigate } from "react-router-dom";
import { useFormik} from "formik";
import * as Yup from "yup";
import axios from "axios";
import swal from "sweetalert";
import LangSwitcher from './common/LanguageSwitcher';

import LoginBanner from '../images/loginbg.png';

import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useTranslation } from "react-i18next";

export default function Login() {
  const { t, i18n } = useTranslation();
  const [clicked, setClicked] = useState('');
  const [passwordType, setPasswordType] = useState("password");
  
  const navigate = useNavigate();
  localStorage.removeItem("otpCounter")

  useEffect(() => {
    if(localStorage.getItem("USERLOGIN") == 'YES') {
      navigate("/features");
    }
  }, []);
  
  const validationSchema = Yup.object().shape({
    email: Yup.string().required(t('validation_email_empty')).email(t('validation_email_invalid')),
    password: Yup.string()
    .required(t('validation_pass_empty'))
    .min(6, t('validation_pass_min'))
    .max(40, t('validation_pass_max')),
  });
  console.log("URL: "+process.env.REACT_APP_API_KEY);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    // validateOnChange: false,
    // validateOnBlur: false,
    onSubmit: async (data) => {
       console.log('input data')
       setClicked('noaction');
      await axios       
        .post(process.env.REACT_APP_API_KEY+"api/login", data, {headers: {
          "Content-type": "Application/json",
          "sellang": localStorage.getItem("selectLang")
        }   
        })
        .then((res) => {
          
          if (res.status === 200) {
            // swal({
            //   title: "Wow!",
            //   text: "Login Successfully!",
            //   icon: "success",
            //   button: "Okay",
            // });
            console.log(res.data);
            //localStorage.setItem("token", res.data.token);
            localStorage.setItem("userData", res.data.id);
            localStorage.setItem("email", res.data.email);
            navigate("/otp-verification");
          } 
          setClicked('');
        }).catch(error => {
            setClicked('');
            swal("Oops", "Invalid email address or password please try again.", "error");
          
          console.log('aya',error.response);
      });
     // console.log(JSON.stringify(data, null, 2));

    },
  });

  
  const handleShowPassword = () => {
    console.log('handleShowPassword');
    if (passwordType === "password") 
      setPasswordType("text");
    else setPasswordType("password");
  }
  const togglePassword =()=> {
    console.log('togglePassword');
    if(passwordType==="password")
    {
     setPasswordType("text")
    } else {
      setPasswordType("password")
    }
  }
  
  return (
    <>
      <div className="login">
        <div className="d-flex flex-column-reverse flex-md-row">
            <div className="w-100 w-md-40">
                <div className="login-form-container">
                <div className="position-relative main-left-form">
                    <div className="login-head">
                      <LangSwitcher/>
                    </div>
                    <div className="login-form-head"> 
                        <div className="form-heading">
                            <h3>{t('login_heading1')}</h3>
                        </div>
                    </div>
                    <div className="login-form"> 
                        <div className="main-form">
                            <div>
                            <form className="row g-3" onSubmit={formik.handleSubmit}>
                                    <Form.Group className="mb-3" controlId="signInEmail">
                                          <Form.Label>{t('login_email')}<span className="text-danger">*</span></Form.Label>
                                          <Form.Control  type="email"
                name="email"
                className="form-control"
                aria-describedby="signInEmail"
                placeholder="example@gmail.com"
                onChange={formik.handleChange}
                value={formik.values.email} />
                <div className="text-danger">
                  {formik.errors.email ? formik.errors.email : null}
                </div>
                                    </Form.Group>
                                    <Form.Group controlId="signInPassword">
                                          <Form.Label>{t('login_password')}<span className="text-danger">*</span></Form.Label>
                                          <div className="icon-input">
                                          <Form.Control type={passwordType}
                name="password"
                className="form-control"
                aria-describedby="signInPassword"
                placeholder="●●●●●●●●"
                onChange={formik.handleChange}
                value={formik.values.password} />
                <span style={{ cursor: "pointer" }} className="field_icon toggle-password" onClick={handleShowPassword}>
                  <i className={ passwordType==='password'? `fa fa-eye`: `fa fa-eye-slash`}  aria-hidden="true" />
                </span>
                </div>
                </Form.Group>
                <div className="text-danger">
                  {formik.errors.password ? formik.errors.password : null}
                </div>
                                  
                                    <div className="text-end mt-3">
                                        <NavLink className="red" to={{ pathname: "/forgot-password" }} >{t('login_forgot')}</NavLink>
                                    </div>
                                    <div className="login-btn-box">
                                        <button disabled = {clicked == 'noaction' ? true : false} type="submit" className={`btn btn-red-bg btn-md ${clicked}`}>{t('login_button')}</button>
                                    </div>

                                    

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                </div>
                <div className="w-100 w-md-60">
                <div className="right-box">
                    <img src={LoginBanner} alt="" className="img-fluid login-bg"/>
                    <div className="banner-text px-4">
                        <div>
                        <p id="welcome">{t('forgot_welcome')}</p>
                        <p>{t('forgot_msg')}</p>
                        <div id="line"></div>
                        <span>{t('forgot_line_msg')}</span>
                        </div>
                    </div>
                </div>
                </div>
                </div>
            </div>
      </>
  )
}